import dayjs from 'dayjs';
import { t } from 'i18next';
import { FC } from 'react';
import { InfiniteScroll } from '../../../../../components/infinite-scroll/infinite-scroll';
import { Rating } from '../../../../../components/rating/rating';
import { overlayKey } from '../../../../../helpers/path';
import { useFlashElement } from '../../../../../hooks/use-flash-element/use-flash-element';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useReviewsStore } from '../../../../../store/use-reviews-store';
import s from './review-cards.module.css';

interface Props {
  onEnd: () => void;
}

export const ReviewCards: FC<Props> = ({ onEnd }) => {
  const { place } = useBranchesStore();
  const { getLocale } = useLang();
  const { reviews, isLoadingFetch } = useReviewsStore();
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const overlayId = params[overlayKey];

  const elementId = overlayId?.split('-').pop();
  useFlashElement({
    isReady: !isLoadingFetch && !!reviews?.length,
    selector: `#card-${elementId}`,
  });

  if (!reviews?.length && !isLoadingFetch) {
    return <div>{t('Здесь пока нет отзывов')}</div>;
  }

  return (
    <ul className={s.feature}>
      {reviews.map((item) => (
        <li key={item.id} className={s.item} id={`card-${item.id}`}>
          <div className={s.title}>
            {!item.rating && item.task_id ? (
              t('Создано из задачи', {
                number: item.task_id,
              })
            ) : (
              <Rating rate={item.rating} readOnly />
            )}
            <span className={s.branch}>
              {getLocale(place?.find((branch) => branch.id === item.place_id)?.name)}
            </span>
          </div>
          <span className={s.content}>{item.content}</span>
          <div className={s.footer}>
            <span className={s.author}>
              {item.full_name} | {item.contact_info}
            </span>
            <span className={s.datetime}>{dayjs(item.created_at).format('D MMM | HH:mm')}</span>
          </div>
        </li>
      ))}
      <InfiniteScroll onEnterView={onEnd} />
    </ul>
  );
};
